module.exports = "/assets/data/05cf78a976e26ee77f48d70afcb0094f-BA1.data.json";